import dayjs from 'dayjs'

/** Giá trị rỗng — theo AntD, hai gạch. Không dùng em dash, không dùng chuỗi trống. */
export const EMPTY = '--'

type MaybeDate = string | number | Date | null | undefined

const fmt = (value: MaybeDate, pattern: string): string => {
  if (value === null || value === undefined || value === '') return EMPTY
  const d = dayjs(value)
  return d.isValid() ? d.format(pattern) : EMPTY
}

/** Định dạng hiển thị và cho picker. */
export const DATE_FORMAT = 'DD/MM/YYYY'
export const DATETIME_FORMAT = 'HH:mm DD/MM/YYYY'
export const DATETIME_SECONDS_FORMAT = 'HH:mm:ss DD/MM/YYYY'

/** Chuỗi gửi lên BE — không đổi. */
export const DATE_WIRE_FORMAT = 'YYYY-MM-DD'
export const DATETIME_WIRE_FORMAT = 'YYYY-MM-DDTHH:mm:ss'

export const formatDate = (value: MaybeDate) => fmt(value, DATE_FORMAT)
export const formatDateTime = (value: MaybeDate) => fmt(value, DATETIME_FORMAT)
export const formatDateTimeSeconds = (value: MaybeDate) => fmt(value, DATETIME_SECONDS_FORMAT)
export const formatTime = (value: MaybeDate) => fmt(value, 'HH:mm')

/** Khoảng thời gian — theo AntD, dấu ngã có khoảng trắng hai bên. */
export const formatDateRange = (from: MaybeDate, to: MaybeDate) =>
  `${formatDate(from)} ~ ${formatDate(to)}`

/** Số: phân cách nghìn bằng dấu chấm, thập phân bằng dấu phẩy (chuẩn Việt Nam). */
export const formatNumber = (value: number | null | undefined, maxFractionDigits = 2): string => {
  if (value === null || value === undefined || Number.isNaN(value)) return EMPTY
  return new Intl.NumberFormat('vi-VN', { maximumFractionDigits: maxFractionDigits }).format(value)
}

export const formatPercent = (value: number | null | undefined, maxFractionDigits = 2): string => {
  if (value === null || value === undefined || Number.isNaN(value)) return EMPTY
  return `${formatNumber(value, maxFractionDigits)}%`
}

/** Đơn vị viết thường, liền số theo AntD: `120kg`. */
export const formatWithUnit = (value: number | null | undefined, unit: string): string => {
  const n = formatNumber(value)
  return n === EMPTY ? EMPTY : `${n}${unit.toLowerCase()}`
}

const mask = (raw: string | null | undefined, head: number, tail: number): string => {
  if (!raw) return EMPTY
  const s = String(raw)
  if (s.length <= head + tail) return '***'
  return `${s.slice(0, head)}****${s.slice(s.length - tail)}`
}

/**
 * Che PII. BẮT BUỘC ở mọi chỗ hiển thị cho vai trò không đủ quyền,
 * và ở cổng tra cứu công khai. Xem .claude/rules/security-floor.md.
 */
export const maskId = (value: string | null | undefined) => mask(value, 3, 4)
export const maskPhone = (value: string | null | undefined) => mask(value, 3, 3)
export const maskAll = (value: string | null | undefined) => (value ? '***' : EMPTY)

/** Email: che phần local, giữ nguyên tên miền để còn nhận ra kênh gửi. */
export const maskEmail = (value: string | null | undefined) => {
  if (!value) return EMPTY
  const at = value.indexOf('@')
  if (at <= 1) return maskAll(value)
  const local = value.slice(0, at)
  const domain = value.slice(at)
  const visible = local.slice(0, Math.min(2, local.length))
  return `${visible}****${domain}`
}
